import { render, staticRenderFns } from "./WebsiteGoodsSkuEdit.vue?vue&type=template&id=b7878c88&"
import script from "./WebsiteGoodsSkuEdit.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsSkuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports